export default "__VITE_ASSET__6ObiZ7P3__"